import React from "react";
import {
  TransitionGroup,
  Transition as ReactTransition
} from "react-transition-group";

const timeout = 300;

const getTransitionStyles = {
  entering: {
    position: "absolute",
    opacity: 0
  },
  entered: {
    transition: `opacity ${timeout * 2}ms ease-in-out`,
    opacity: 1
  },
  exiting: {
    transition: `all ${timeout}ms ease-in-out`,
    opacity: 0
  }
};

class Transition extends React.PureComponent {
  smoothScroll(duration) {
    var target = document.querySelector("#page");
    var targetPos = target.firstElementChild.offsetTop;
    var startPos = window.pageYOffset;
    var distance = targetPos - startPos;
    var startTime = null;

    function animate(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      var run = Math.easeInOutQuad(timeElapsed, startPos, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animate);
    }

    Math.easeInOutQuad = function(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };
    requestAnimationFrame(animate);
  }
  componentDidUpdate() {
    return window.innerWidth < 685
      ? setTimeout(this.smoothScroll(timeout), 0)
      : false;
  }
  render() {
    const { children, location } = this.props;
    return (
      <TransitionGroup>
        <ReactTransition
          key={location.pathname}
          timeout={{
            enter: timeout,
            exit: timeout
          }}
        >
          {status => (
            <div
              style={{
                ...getTransitionStyles[status]
              }}
            >
              {children}
            </div>
          )}
        </ReactTransition>
      </TransitionGroup>
    );
  }
}

export default Transition;
